/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * The standard OAuth2 error response returned by `POST /api/connect/token` (e.g. HTTP 400 with
 * `error=invalid_grant` for bad credentials or an invalid/expired refresh token). Documentation
 * only; the response is produced by OpenIddict.
 * @export
 * @interface OAuthErrorResponseModel
 */
export interface OAuthErrorResponseModel {
    /**
     * The OAuth2 error code, e.g. `invalid_grant` or `unsupported_grant_type`.
     * @type {string}
     * @memberof OAuthErrorResponseModel
     */
    error?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OAuthErrorResponseModel
     */
    $type?: OAuthErrorResponseModelTypeEnum;
    /**
     * A human-readable description of the error.
     * @type {string}
     * @memberof OAuthErrorResponseModel
     */
    errorDescription?: string | null;
}


/**
 * @export
 */
export const OAuthErrorResponseModelTypeEnum = {
    PtwPtw100WebMvcModelsTokenAuthOAuthErrorResponseModelPtwPtw100WebMvc: 'Ptw.Ptw100.Web.Mvc.Models.TokenAuth.OAuthErrorResponseModel, Ptw.Ptw100.Web.Mvc'
} as const;
export type OAuthErrorResponseModelTypeEnum = typeof OAuthErrorResponseModelTypeEnum[keyof typeof OAuthErrorResponseModelTypeEnum];



/**
 * Check if a given object implements the OAuthErrorResponseModel interface.
 */
export function instanceOfOAuthErrorResponseModel(value?: unknown): value is OAuthErrorResponseModel {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(OAuthErrorResponseModelTypeEnum)[0];
}

export function OAuthErrorResponseModelFromJSON(json: any): OAuthErrorResponseModel {
    return OAuthErrorResponseModelFromJSONTyped(json, false);
}

export function OAuthErrorResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthErrorResponseModel {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
        '$type': json['$type'] == null ? undefined : json['$type'],
        'errorDescription': json['error_description'] == null ? undefined : json['error_description'],
    };
}

export function OAuthErrorResponseModelToJSON(value?: OAuthErrorResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'error': value['error'],
        '$type': value['$type'],
        'error_description': value['errorDescription'],
    });
}

